export * from './objekt.component';
export * from './objekt.component.module';